import React, { FC } from 'react'
import { PatientInformationsGroupContainerProps } from './PatientInformationsGroupContainer.model'
import styles from './PatientInformationsGroupContainer.module.scss'

export const PatientInformationsGroupContainer: FC<PatientInformationsGroupContainerProps> = ({
  children,
}) => {
  return <div className={styles.patientInformationsGroupContainer}>{children}</div>
}
